module.exports = __webpack_public_path__ + "img/401.3ff7d04a.svg";